import gql from 'graphql-tag'

import { PublicExpoRegisterMutation } from '../../../types/api'

export const register = {
  mutation: gql`
    mutation publicExpoRegister(
      $event: ID!
      $eventSlot: ID!
      $emailCode: String!
      $visitors: [PublicExpoVisitorInput!]!
      $optinRegistration: Boolean!
    ) {
      publicExpoRegister(
        event: $event
        eventSlot: $eventSlot
        emailCode: $emailCode
        visitors: $visitors
        optinRegistration: $optinRegistration
      ) {
        id
        first_name
        last_name
        email
        checked_in_at
      }
    }
  `,
  transformer: (response: PublicExpoRegisterMutation) => {
    return response.publicExpoRegister
  },
}
